var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundImage:'url('+ require('@/assets/openApp.jpg') +')'}),attrs:{"id":"main"}},[_c('ShareButton',{attrs:{"source":_vm.source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }